import { EmployeeListEffects } from './employee-list/employee-list.effects';
import { FactoryListEffects } from './factory-list/factory-list.effects';
import { FactoryConfigEffects } from './factory-config/factory-config.effects';
import { LearningCurveEffects } from './learning-curve/learning-curve.effects';
import { FactoryShiftEffects } from './factory-shift/factory-shift.effects';
import { FactoryProductLineEfficiencyEffects } from './product-line-efficiency/product-line-efficiency.effects';
import { OrderListEffects } from './order-list/order-list.effects';
import { TnAOrderTemplateEffects } from './tna-order-template/tna-order-template.effects';

import { TnaTemplateEffects } from './tna-templates/tna-templates.effects';
import { OrderAttributesEffects } from './order-attributes/order-attributes.effects';
import { OrderDetailsEffects } from './order-details/order-details.effects';
import { TnaBoardEffects } from './tna-board/tna-board.effects';
import { TnaUpdateEffects } from './tna-updates/tna-updates.effects';

import { LlBoardEffects } from './ll-board/ll-board.effects';
import { HlBoardEffects } from './hl-board/hl-board.effects';
import { TnaApprovalsEffects } from './tna-approvals/tna-approvals.effects';
import { ExcelManagementEffects } from './excel-management/excel-management.effects';
import { OrderChecklistEffects } from './order-checklist/order-checklist.effects';
import { ProcessMappingEffects } from './process-mapping/process-mapping.effects';
import { ProcessBoardsEffects } from './process-boards/process-boards.effects';

export const plani8Effects = [
  FactoryListEffects,
  FactoryConfigEffects,
  FactoryShiftEffects,
  LearningCurveEffects,
  EmployeeListEffects,
  FactoryProductLineEfficiencyEffects,
  TnaTemplateEffects,
  OrderAttributesEffects,
  OrderListEffects,
  TnAOrderTemplateEffects,
  OrderDetailsEffects,
  TnaBoardEffects,
  TnaUpdateEffects,
  TnaApprovalsEffects,
  LlBoardEffects,
  HlBoardEffects,
  ExcelManagementEffects,
  OrderChecklistEffects,
  ProcessMappingEffects,
  ProcessBoardsEffects,
];
